import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Box,
} from "@mui/material";
import "./styles.css";
import KeyboardVoiceRoundedIcon from "@mui/icons-material/KeyboardVoiceRounded";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import LoopOutlinedIcon from "@mui/icons-material/LoopOutlined";
import { useTranslationSetup } from "../../utils/useTranslationSetup.js";

const DeleteAudioDialog = ({
  isDialogOpen,
  setDialogOpen,
  setHideSlider,
  setAudioBlob,
}) => {
  const { t } = useTranslationSetup();
  const handleClose = () => {
    setDialogOpen(false);
  };

  return (
    <Dialog
      className="delete-audio"
      open={isDialogOpen}
      aria-labelledby="delete-audio-title"
    >
      <DialogTitle
        id="delte-audio-dialog-title"
        className="delete-audio-dialog-title"
      >
        <Box className="keyboard-icon-box">
          <KeyboardVoiceRoundedIcon className="keyboard-voice-rounded-icon" />
          <CloseOutlinedIcon className="close-outlined-icon" />
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="save-result-dialog-description"
          className="save-result-dialog-desc"
        >
          <Typography className="retake-audio-text">
            {t("retake_audio")}
          </Typography>

          <Typography className="retake-audio-desc">
            {t("retake_audio_desc")}
          </Typography>
          <Box className="delete-audio-box">
            <Button
              className="delete-audio-icon"
              variant="text"
              startIcon={<CloseOutlinedIcon />}
              onClick={() => {
                handleClose();
              }}
            >
              {t("cancel")}
            </Button>
            <Button
              variant="contained"
              startIcon={
                <LoopOutlinedIcon
                  sx={{
                    transform: "rotateY(180deg) rotate(132deg)",
                  }}
                />
              }
              className="retake-audio-button"
              onClick={() => {
                setAudioBlob(null);
                handleClose();
                setHideSlider(false);
              }}
              disableElevation
            >
              {t("retake")}
            </Button>
          </Box>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteAudioDialog;
